<template>
  <span
    ><span class="status-point" :class="'bg-' + type"></span>
    <span :class="'text-' + type">
      {{ name }}
    </span></span
  >
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  }
}
</script>